import axios from 'axios'
import ExpirySession from '../utils/expirySession'

// export const testBaseURL = 'https://apiv2.staging.whooshing.xyz/api/v2'
export const liveBaseURL = process.env.REACT_APP_API_BASE_URL
// export const liveBaseURL = 'https://api.main.whooshing.xyz/api/v1'

const instance = axios.create({
  baseURL: liveBaseURL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
  },
})

instance.interceptors.request.use(
  (config) => {
    const { access_token } = ExpirySession.get('user')

    if (access_token) {
      config.headers.Authorization = `Bearer ${access_token}`
    }
    return config
  },
  (err) => {
    return Promise.reject(err)
  },
)

export default instance
